import { render, staticRenderFns } from "./CInfoHomeComp.vue?vue&type=template&id=64d41dad&"
import script from "./CInfoHomeComp.vue?vue&type=script&lang=js&"
export * from "./CInfoHomeComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports